export const LOADER_STATUS = "boilderplate/GST8_PREPARE/LOADER_STATUS";
export const PROFILE_DATA = "boilderplate/GST8_PREPARE/PROFILE_DATA";
export const SET_ENTITY_LIST = "boilderplate/GST8_PREPARE/SET_ENTITY_LIST";
export const DEFAULT_ENTITY = "boilderplate/GST8_PREPARE/DEFAULT_ENTITY";
export const STORE_GSTIN_GSTR8 = "boilderplate/GSTR8_PREPARE/STORE_GSTIN_GSTR8";
export const STORE_PERIOD_SINGLE ="boilerplate/GSTR8_PREPARE/STORE_PERIOD_SINGLE";
export const REJECTED_TABLE_DATA ="boilerplate/GSTR8_PREPARE/REJECTED_TABLE_DATA";
export const GROSS_SUMMARY_TABLE_DATA ="boilerplate/GSTR8_PREPARE/GROSS_SUMMARY_TABLE_DATA";
export const SAVE_TABLE_DATA ="boilerplate/GSTR8_PREPARE/SAVE_TABLE_DATA";
export const SET_IS_EDIT = 'boilderplate/GSTR8_PREPARE/SET_IS_EDIT';
export const SET_EDITED_DATA = 'boilderplate/GSTR8_PREPARE/SET_EDITED_DATA';
export const EDITED_VALUE = 'boilderplate/GSTR8_PREPARE/EDITED_VALUE';
export const COMPARATIVE_TABLE_DATA = 'boilderplate/GSTR8_PREPARE/COMPARATIVE_TABLE_DATA';
export const HISTORY_TABLE_DATA = 'boilderplate/GSTR8_PREPARE/HISTORY_TABLE_DATA';
export const SAVE_TOTAL_PAGES = 'boilderplate/GSTR8_PREPARE/SAVE_TOTAL_PAGES';




